import useSWR from 'swr';

async function fetchBanner(lang: string) {
  const searchParams = new URLSearchParams();
  searchParams.set('appId', 'app_ee968e983074cb090e6f12cd75b63bb3');
  searchParams.set('lang', lang);
  searchParams.set('isPopup', String(false));
  searchParams.set('isDisplay', 'true');

  const response = await fetch(
    `${process.env.VITE_API_BANNER_URL}/api/banner-image-info/config?${searchParams.toString()}`,
  );

  if (!response.ok) {
    throw Error('Fetch fail');
  }

  const data = await response.json();

  return data as {
    sliderImages: {
      imageUrl: string;
      inAppBrowserUrl: string;
      isInApp: boolean;
      isDisplay: boolean;
      isPopup: boolean;
      orderId: number;
      navigateTo: string;
      appId: string;
      lang: string;
      id: number;
    }[];
  };
}

export function useBanner(lang: string) {
  const response = useSWR(`/banner/${lang}`, () => fetchBanner(lang), { dedupingInterval: 2000 });

  return response;
}
